export default {
  props: {
    value: {
      type: null,
    },
    id: String,
    closeOnSelect: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    preloading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: [],
      optionsLimit: 25,
      loading: false,
      model: this.value,
    };
  },
  methods: {
    clear() {
      this.$emit('input', []);
    },
    updateValue(value) {
      this.model = value;
      this.$emit('input', value);
    },
    getItemById(id) {
      const opt = this.$refs.multiSelect.options;
      for (let i = 0; i < opt.length; i += 1) {
        if (opt[i][this.trackBy] === id) {
          return opt[i];
        }
      }
      return null;
    },
  },
  watch: {
    value(v) {
      this.model = v;
    },
  },
};
